import useAppQuery from 'hooks/useAppQuery';
import {
  IntegrationSettingsQueryOptions,
  integrationsSettingsQuery,
} from 'pages/channels/integrationSettingsQuery';

const useFetchIntegrationSettingsList = ({
  ...options
}: IntegrationSettingsQueryOptions) => {
  return useAppQuery(
    integrationsSettingsQuery({
      ...options,
    }),
  );
};

export default useFetchIntegrationSettingsList;
